import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  FuelType,
  FuelTypeValues,
  ImpactCo2Answer,
  ValuesGenerator,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'GENERATOR';
const SECTORS: Sector[] = ['SITE'];

export function mapToGeneratorAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesGenerator>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const hasGenerator = mapToHasGenerator(row);
  const fuelType = mapToFuelType(row);
  const fuelConsumption = mapToFuelConsumption(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      hasGenerator,
      fuelType,
      fuelConsumption,
    },
  };
  return answer;
}

function mapToHasGenerator(row: ImportedRow): boolean {
  return true;
}

function mapToFuelType(row: ImportedRow): FuelType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<FuelType>(tgsValue, FuelTypeValues);
  if (!result) {
    throw new ImportMappingError('fuelType', tgsValue, row);
  }
  return result;
}

function mapToFuelConsumption(row: ImportedRow): number {
  const tgsValue = row['Volume (L)'];
  const result = parseInt(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('fuelConsumption', tgsValue, row);
  }
  return result;
}
